
export const fetchUrl = (url) =>
fetch(url)
    .then(response => response)
    .catch(err => {
        console.log("Fetch fail "+url, err);
        return null;
    });